import request from '@/utils/request'

//Load Recruitments History
export function loadPaginatedRecruitment(params) {
  return request({ url: 'vrecruitment', method: 'post', data: params })
} 